var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: _vm.width})},[_c('v-text-field',_vm._g(_vm._b({staticClass:"search-field",attrs:{"prepend-inner-icon":"mdi-magnify","rounded":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }